export const removeAlphabeticCharacteres = (value: string): string =>
  value.replace(/[^\d]/g, '')

export const stringNullOrEmpty = (value: string | null | undefined) =>
  !value || value.length === 0
